import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { IAppCoreState } from 'src/app/core/state';
import { selectAppChatComments } from 'src/app/core/state/selectors';
import { RightPanelItem, WriteupDetailRightPanelAction } from 'src/app/feature/writeups-detail/state/actions/writeup-detail-right-panel.action';
import { DealRoute } from 'src/app/shared/model/api';
import { SubSink } from 'subsink';
import * as appNotificationsActions from 'src/app/core/state/actions/app-notification.action';

@Component({
  selector: 'app-con-app-chat-notification-panel',
  templateUrl: './con-app-chat-notification-panel.component.html',
  styleUrls: ['./con-app-chat-notification-panel.component.scss']
})
export class ConAppChatNotificationPanelComponent implements OnInit {
  @Output() messageEvent = new EventEmitter<any>();
  public comments: any[] = [];
  private readonly subs = new SubSink();
  constructor(private readonly _store: Store<IAppCoreState>, private readonly router: Router) { }
  
  ngOnInit(): void {
    this.subs.sink = this._store.select(selectAppChatComments).subscribe(comments => {
      this.comments = comments;
      setTimeout(() => {
        if (comments.length == 0) {
          if (document.getElementById("crossIcon")) {
            document.getElementById("crossIcon").focus();
          }
        } else if (document.getElementById("ChatCard0")) {
            document.getElementById("ChatCard0").focus();
          }
     }, 500);
    });
  }
  close() {
    this.messageEvent.emit(false)
  }
  clearall(){
    this._store.dispatch(appNotificationsActions.ClearAllChatComments());
  }
  clear(comment){
    this._store.dispatch(appNotificationsActions.ClearChatComment({ payload: comment }));
  }
  public navigateToWriteup(comment) {
    this.clear(comment)
    this.close();
    this._store.dispatch(new WriteupDetailRightPanelAction(RightPanelItem.Notes));
    let navExtra = this.getNavigationExtras(comment);
    this.router.onSameUrlNavigation = "reload";
    this.router.navigate(['wd/writeup-detail'], navExtra);
  }

  private getNavigationExtras(comment) {
    const dealRoute: DealRoute = {
      customer: comment?.customer ? comment.customer.firstName + comment.customer.lastName : undefined,
      dealType :comment.deal.paymentType === 'APR' ? 'finance' : comment.deal.paymentType.toLowerCase(),
      dealStatus: comment.deal.status,
      dealTransactionId: comment.deal.dealTransactionId,
      salesConsultant: comment.type === 'DEAL_COMMENT' ? comment.deal.dealTermComment.commentGivenBy : comment.deal.salesPerson,
      isNotification: false,
      timestamp: Date.now(),
    };
  
    const navigationExtras: NavigationExtras = {
      // queryParams: { "dealRoute": JSON.stringify(dealRoute) },
      skipLocationChange: false,
      state: dealRoute
    };
  
    return navigationExtras;
  }
  
}
